/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FontSizeEditing from './fontsizeediting';
import FontSizeUI from './fontsizeui';
import '../../theme/style.css';

export default class FontSize extends Plugin {
	static get requires() {
		return [ FontSizeEditing, FontSizeUI ];
	}

	static get pluginName() {
		return 'CustomFontSize';
	}
}
